import { Fragment } from 'react';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import { TMeetingRecord } from '@/common/basis/types/database/tmeeting-record';

function App(props: { recordList?: TMeetingRecord.Item[] }) {
  const recordList = props.recordList;
  const { t } = useTranslation();

  return recordList?.length ? (
    <div className='overflow-hidden rounded-xl bg-[#fff] p-3 py-4'>
      <div>
        <span>{t('joinRecord')}</span>
      </div>
      <div className='overflow-hidden pb-2 pt-1'>
        {recordList?.map((value, idx) => (
          <Fragment key={idx}>
            {value?.joinTime ? (
              <div className='mt-1 flex items-center justify-start text-[#888]'>
                <span className='mr-2 w-10'>{dayjs(value.joinTime).format('HH:mm')}</span>
                <span>{t('joinMeeting')}</span>
              </div>
            ) : (
              <></>
            )}
            {value?.leftTime ? (
              <div className='mt-1 flex items-center justify-start text-[#888]'>
                <span className='mr-2 w-10'>{dayjs(value.leftTime).format('HH:mm')}</span>
                <span>{t('leftMeeting')}</span>
              </div>
            ) : (
              <></>
            )}
          </Fragment>
        ))}
      </div>
    </div>
  ) : (
    <></>
  );
}

export default App;
